<style lang="less">
@import '@/components/ai/zzl/zzl-ai-workbench.less';
.pdf-export {
  .markdown-body h1 {
    margin-top: 0 !important;
  }
}
</style>
<template>
  <div class="zzl-view-page" style="height:100%;overflow:hidden;display:flex;flex-direction:column;min-height:0;">
    <div class="flex-wrap flex-between" style="height:50px;padding:0 10px;background:linear-gradient(to right,#fff,var(--border));">
      <div class="flex-wrap split5">
        <Select v-model="project_id" filterable style="width:300px" placeholder="选择项目" @on-change="getProjectData()">
          <Option
            v-for="pr in projects"
            :key="pr.id"
            :value="pr.id"
            :label="pr.name"
          >
            {{ pr.name }}
            <Tag>{{ pr.finished ? '已完成' : '进行中' }}</Tag>
            <Tag>{{ pr.group }}</Tag>
          </Option>
        </Select>
        <Select v-model="task_id" style="width:340px" placeholder="选择模块" filterable clearable @on-change="getTaskData">
          <OptionGroup v-for="g in tasks" :key="g.id" :label="g.name">
            <Option v-for="p in g.works" :key="p.id" :value="p.id">{{ p.name }}</Option>
          </OptionGroup>
        </Select>
      </div>
      <div class="zzl-view-top-actions flex-wrap">
        <Button class="zzl-view-top-refresh" type="default" :disabled="!project_id" :loading="dataLoading" @click="getProjectData">刷新列表</Button>
      </div>
    </div>

    <div class="zzl-view-split" style="flex:1;min-height:0;">
      <div class="zzl-view-left" style="padding:12px;display:flex;flex-direction:column;min-height:0;">
        <Spin v-if="dataLoading" fix size="large">
          <div class="zzl-view-data-loading-text">加载数据中…</div>
        </Spin>
        <div class="zzl-view-left-half zzl-view-left-half--data">
          <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:8px;flex-shrink:0;">
            <div class="zzl-view-section-title" style="margin:0;">数据下载和清理</div>
            <div class="flex-wrap" style="align-items:center;gap:8px;">
              <Button type="primary" icon="md-download" :disabled="!task_id || dataLoading" :loading="dataLoading" @click="getTaskData">获取数据</Button>
              <Button type="warning" @click="CopyToClip">复制数据</Button>
            </div>
          </div>
          <div class="zzl-view-left-toolbar" style="margin-bottom:8px;flex-shrink:0;">
            <div class="flex-wrap" style="align-items:center;flex-wrap:wrap;gap:8px;">
              <i-switch v-model="extractForm" size="small" @on-change="cleanData" />
              <span style="font-size:12px;">提取表格</span>
              <i-switch v-model="onlyQuestion" size="small" @on-change="cleanData" />
              <span style="font-size:12px;">隐藏合规项</span>
              <span style="font-size:12px;color:var(--subtext2);">字符数 {{ aiText.length }}</span>
            </div>
          </div>
          <div class="zzl-view-left-track flex-wrap split5" style="margin-bottom:8px;align-items:center;flex-wrap:wrap;gap:8px;flex-shrink:0;">
            <span style="font-size:12px;color:#64748b;">跟踪记录</span>
            <BaseDate v-model="tracking_startDate" placeholder="开始日期" />
            <BaseDate v-model="tracking_endDate" placeholder="结束日期" />
            <Button size="small" @click="cleanData">按跟踪刷新</Button>
          </div>
          <div class="zzl-view-left-textarea-wrap">
            <Input
              type="textarea"
              v-model="aiText"
              :rows="4"
              style="width:100%;flex:1;min-height:0;"
              placeholder="先获取模块数据后，清洗结果将显示在此。"
            />
          </div>
        </div>
        <div class="zzl-view-left-half zzl-view-left-half--prompt">
          <div class="zzl-view-left-prompt-body">
            <AiPromptPanel
              v-model="userText"
              mod="zzl-work"
              :textarea-rows="4"
              :hide-mod-hint="true"
              split-head
            >
              <template slot="head-left">
                <div class="zzl-view-section-title flex-wrap" style="margin:0;align-items:baseline;gap:8px;">
                  提示词
                  <span style="font-size:12px;font-weight:400;color:var(--subtext2);">
                    （{{ labelForMod('zzl-work') }} · zzl-work）
                  </span>
                </div>
              </template>
            </AiPromptPanel>
          </div>
        </div>
      </div>

      <div class="zzl-view-right" style="padding:10px;display:flex;flex-direction:column;min-height:0;">
        <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:6px;">
          <div class="zzl-view-section-title" style="margin:0;">报告</div>
          <div class="zzl-view-right-actions flex-wrap" style="gap:8px;justify-content:flex-end;margin-left:auto;">
            <Button type="primary" icon="md-play" :loading="ai_executings" :disabled="aiText.length < 10" @click="CreateByAI">
              {{ ai_executings ? '生成中…' : (result ? '重新生成' : '生成报告') }}
            </Button>
            <Button v-if="images.length" @click="copyImageAddresses">复制图片地址</Button>
            <Button @click="copyReportMd" :disabled="!result">复制 Markdown</Button>
            <Button @click="exportPDF" :disabled="!result">导出 PDF</Button>
            <AiSaveToKnowledgeButton :content="result" :disabled="!result || ai_executings" :file-name="zzlSaveFileName" />
          </div>
        </div>
        <div class="zzl-view-right-report">
          <AiMarkdownStreamPanel
            ref="reportPanel"
            class="pdf-export"
            style="flex:1;min-height:0;"
            :value="result"
            :streaming="ai_executings"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
moment.locale('zh-cn');
import { deepCleanTask, renderEFormMap, extractAttachments } from '@/components/ai/clean';
import mixinPageState from '@/mixins/page_state';
import zzlAiStreamReport from '@/components/ai/zzl/mixins/zzlAiStreamReport';
import AiPromptPanel from '@/components/ai/AiPromptPanel.vue';
import AiMarkdownStreamPanel from '@/components/ai/AiMarkdownStreamPanel.vue';
import {labelForMod} from '@/components/ai/aiPromptModLabels';
import { buildZzlPdfFileStem } from '@/components/ai/zzl/zzl-report-filename';

export default {
  components: { AiPromptPanel, AiMarkdownStreamPanel },
  mixins: [mixinPageState, zzlAiStreamReport],
  data() {
    return {
      pageStateKey: 'ai_zzl_work_module',
      pageStateFields: ['project_id', 'task_id', 'onlyQuestion', 'extractForm', 'tracking_startDate', 'tracking_endDate', 'userText'],
      aiText: '',
      ai_executings: false,
      extractForm: false,
      onlyQuestion: false,
      result: '',
      images: [],
      files: [],
      rawTasks: [],
      tracking_startDate: null,
      tracking_endDate: null,
      userText: '我们是一家监理及全过程咨询服务的公司，目前公司全面上线了任务系统。以下是一个任务的完整数据，请从监理服务质量检查和风险管控角度，严格结合以下任务数据执行全维度分析，不关联上下文数据。分五部分内容，一是任务执行总体概况（严格统计工作模块下工作任务的数量、工作任务的状态、工作跟踪记录的数量、其中工作表单的数量）；二是评估整体监理服务质量（评估工作任务是否覆盖该工作模块规范规定的主要监理工作，验证问题发现能力，提取所有\'不符合\',\'否\',\'不合格\'等质量问题（须有影像照片记录），验证每个问题是否闭环（需有对应回复内容），计算整改时效（问题发现→问题回复时长））；三是如有潜在风险请给出分析和评价（重点对问题发现数量，问题整改回复情况，记录中“/”代表本次检查无该项）；四是对工作跟踪记录执行人进行工作量统计（ 严格统计[]内的人即为工作跟踪记录执行人）。五是从项目部监理服务质量和风险管控程度对项目部进行评价，分为优秀、良好、合格、不合格',
      tasks: [],
      task_id: '',
      projects: [],
      project_id: 'pid65054f01eabec',
      view: 'recent',
      dataLoading: false,
    };
  },

  mounted() {
    this.$api.afterLogin(() => {
      this.getProjects();
      this.getProjectData();
    });
  },
  methods: {
    labelForMod,
    zzlReportPdfStem() {
      const project = this.projects.find((p) => p.id === this.project_id);
      let taskName = '';
      for (const g of this.tasks) {
        if (g.works) {
          const w = g.works.find((x) => x.id === this.task_id);
          if (w) {
            taskName = w.name;
            break;
          }
        }
      }
      return buildZzlPdfFileStem(['模块数据', project && project.name, taskName || 'module']);
    },
    getProjects() {
      this.$api.get('logined_zzl/projects').then((res) => {
        this.projects = res.data.data;
      });
    },
    getProjectData() {
      if (!this.project_id) {
        return;
      }
      this.dataLoading = true;
      this.$api.post('logined_zzl/get_modules', { pid: this.project_id }).then((res) => {
        this.tasks = res.data.data || [];
        if (this.tasks.length > 0) {
          const withWorks = this.tasks.map((v) => v.works).filter((v) => Array.isArray(v) && v.length > 0);
          if (withWorks.length > 0 && !this.task_id) {
            this.task_id = withWorks[0][0].id;
          }
        }
      }).catch((e) => {
        console.error(e);
        this.Error(e && e.message ? e.message : '获取模块列表失败');
      }).finally(() => {
        this.dataLoading = false;
      });
    },
    getTaskData() {
      if (!this.task_id) {
        return;
      }
      this.dataLoading = true;
      this.$api.post('logined_zzl/get_module_data', { id: this.task_id }).then((res) => {
        this.rawTasks = res.data.data;
        this.cleanData();
      }).catch((e) => {
        console.error(e);
        this.Error(e && e.message ? e.message : '获取模块数据失败');
      }).finally(() => {
        this.dataLoading = false;
      });
    },

    cleanData() {
      this.__savePageState();
      this.images = [];
      this.files = [];
      const task = this.tasks.map((v) => v.works).map((v) => v.find((t) => t.id == this.task_id)).filter((v) => v)[0];
      if (!task) {
        return;
      }
      const tasks = this.rawTasks;
      const eformmap = {};

      this.aiText = `本任务名称为【${task.name}】\n# 以下为所有任务数据\n` + tasks.map((t) => deepCleanTask(t, this.tracking_startDate, this.tracking_endDate, null, this.extractForm ? eformmap : null, this.onlyQuestion)).join('\n');
      if (this.extractForm) {
        this.aiText += renderEFormMap(eformmap);
      }
      const { images, files, text } = extractAttachments(this.aiText);
      this.images = images;
      this.files = files;
      this.aiText = text;
    },
    async CopyToClip() {
      const text = this.aiText || '';
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          const successful = document.execCommand('copy');
          if (!successful) {
            throw new Error('复制失败');
          }
          document.body.removeChild(textarea);
        }
        this.Success('复制成功');
        return true;
      } catch (err) {
        console.error('复制失败:', err);
        return false;
      }
    },
  },
};
</script>
